import { useMemo, useState } from 'react';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';
import PopupResult from '@r1-frontend/ui-react/components/popups/popupResult';
interface IPopupState {
    isOpen: boolean,
    title: string,
    text: string,
    type: EResultPopupStatus,
}

export type TPopupState = Omit<IPopupState, 'isOpen'>;

/**
 * Returns a popup component, and a function to show it.
 */
export const useResultPopup = (onClickClose?: () => void): [() => JSX.Element, (nextState: TPopupState) => void] => {
    const [state, setState] = useState<IPopupState>({
        isOpen: false,
        title: '',
        text: '',
        type: EResultPopupStatus.DEFAULT,
    });

    const onPopupResultClose = () => {
        setState(prevState => ({ ...prevState, isOpen: false }));
        typeof onClickClose === 'function' && onClickClose();
    };

    const result: [() => JSX.Element, (nextState: TPopupState) => void] = useMemo(() => (
        [
            () => <PopupResult
                isOpen={state.isOpen}
                onClose={onPopupResultClose}
                title={state.title}
                text={state.text}
                type={state.type}
            />,
            (nextState: TPopupState) => setState({ isOpen: true, ...nextState }),
        ]
    ), [state]);

    return result;
};
